import {isShowElemInCountry} from "../helpers/localizeFeatures";

const withAccessInCountries = Component => (props) =>
    isShowElemInCountry(props.hideInCountries) && <Component {...props} />

export default withAccessInCountries